export const toTree = (array, { id, parentId }) => {
  const tree = [];
  const lookup = {};
  array.forEach((item) => {
    const _id = item[id];
    lookup[_id] = {
      data: item,
      children: [],
      level: 0,
      isLeaf: false,
      isExpanded: false,
      isSelected: false
    };
  });
  array.forEach((item) => {
    const _parentId = item[parentId];
    const _id = item[id];
    const _node = lookup[_id];
    if (_parentId === null) {
      lookup[_id].level = 1;
      tree.push(_node);
    } else {
      const parentNode = lookup[_parentId];
      if (parentNode) {
        lookup[_id].level = parentNode.level + 1;
        parentNode.children.push(_node);
      }
    }
  });
  array.forEach((item) => {
    const _id = item[id];
    lookup[_id].isLeaf = lookup[_id].children.length === 0;
  });
  return tree;
};
export const getChildren = (tree, nodeId, id) => {
  let children = [];
  const findNode = (node) => {
    if (node.data[nodeId] === id) {
      children = node.children;
    } else {
      node.children.forEach(findNode);
    }
  };
  tree.forEach(findNode);
  return children;
};
export const forEachTree = (tree, callback) => {
  tree.forEach((node) => {
    callback(node);
    node.children.forEach(callback);
  });
};
export const expandAllNodes = (tree) => {
  forEachTree(tree, (node) => {
    node.isExpanded = true;
  });
};
export const collapseAllNodes = (tree) => {
  forEachTree(tree, (node) => {
    node.isExpanded = false;
  });
};
export const expandNode = (tree, nodeId, id) => {
  const traverse = (node) => {
    if (node.data[nodeId] === id) {
      node.isExpanded = true;
      return true;
    }
    if (node.children) {
      for (const child of node.children) {
        if (traverse(child)) {
          node.isExpanded = true;
          return true;
        }
      }
    }
    return false;
  };
  for (const node of tree) {
    traverse(node);
  }
  return tree;
};
